// extracted by mini-css-extract-plugin
export var closeButton = "_3r-3";
export var header = "_3r-0";
export var link = "_3r-1";
export var retryButton = "_3r-2";